// extracted by mini-css-extract-plugin
module.exports = {"list":"list_list__2ZXKC","list__item":"list_list__item__3BkQz"};